import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Route } from '@angular/router';
import { AuthenticationService } from '../services/authentication/authentication.service';
import {Roles} from "./roles";

@Injectable()
export class AdminGuard implements CanActivate {

	constructor(private router: Router,
		private authService: AuthenticationService) { }

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		if (this.authService.getUser().userRole === Roles.Administrator) {
			return true;
		}

		
		// not logged in so redirect to login page with the return url and return false
		this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
		return false;
	}
}



// WEBPACK FOOTER //
// ./src/app/guards/admin.gaurd.ts